export { default as WidgetCollection } from './WidgetCollection';



// WEBPACK FOOTER //
// ./~/@girder/slicer_cli_web/collections/index.js